import { createI18n } from 'vue-i18n';
import ZH from './lang/zh.js';
import EN from './lang/en.js';
import DE from './lang/de.js';
import TW from './lang/tw.js';
import ES from './lang/es.js';
import FR from './lang/fr.js';
import JA from './lang/ja.js';
import KO from './lang/ko.js';
import RU from './lang/ru.js';
import CS from './lang/cs.js';
import PT from './lang/pt.js';
import PL from './lang/pl.js';
import NL from './lang/nl.js';
import TR from './lang/tr.js';
import TH from './lang/th.js';
import IT from './lang/it.js';
import UK from './lang/uk.js';
import HE from './lang/he.js';
const messages = {
  zh: { ...ZH  },//简体
  en: { ...EN  },//英语
  de: { ...DE  },//德语
  tw: { ...TW  },//繁体，香港、台湾统一用台湾code显示
  es: { ...ES  },//西班牙语
  fr: { ...FR  },//法语
  ja: { ...JA  },//日语
  ko: { ...KO  },//韩语
  ru: { ...RU  },//俄语
  cs: { ...CS  },//捷克语
  pt: { ...PT  },//葡萄牙语
  pl: { ...PL  },//波兰语
  nl: { ...NL  },//荷兰语
  tr: { ...TR  },//土耳其语
  th: { ...TH  },//泰语
  it: { ...IT  },//意大利语
  uk: { ...UK  },//乌克兰语
  he: { ...HE  },//希伯来语
};
 
const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'en',
  messages
});
export default i18n;